<template>
    <!-- A two-option segmented control, in the report designs' style: a blue
         outline, the active option solid blue and the other white with blue
         text. Reusable anywhere two mutually-exclusive choices need to be
         explicit (Include/Exclude, On Demand/Group Reports, etc.). -->
    <div    role="radiogroup"
            :aria-label="ariaLabel"
            class="inline-flex w-full overflow-hidden rounded-md border border-blue-600 bg-white sm:w-auto">
        <button type="button"
                role="radio"
                :aria-checked="isOn"
                :disabled="disabled"
                :class="buttonClass(isOn)"
                @click="select(onValue)">
            {{ onLabel }}
        </button>
        <button type="button"
                role="radio"
                :aria-checked="! isOn"
                :disabled="disabled"
                :class="buttonClass(! isOn)"
                @click="select(offValue)">
            {{ offLabel }}
        </button>
    </div>
</template>

<script>
export default {
    name: "SegmentedToggle",
    emits: ['update:modelValue'],
    props: {
        // The current value. When onValue/offValue are left at their boolean
        // defaults this is a plain boolean; pass onValue/offValue to switch
        // between any two values (strings, numbers, etc.).
        modelValue: {
            default: false,
        },
        onLabel: {
            type: String,
            default: 'On',
        },
        offLabel: {
            type: String,
            default: 'Off',
        },
        onValue: {
            default: true,
        },
        offValue: {
            default: false,
        },
        ariaLabel: {
            type: String,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        isOn() {
            return this.modelValue === this.onValue
        },
    },
    methods: {
        select(value) {
            if (this.disabled || value === this.modelValue) {
                return
            }

            this.$emit('update:modelValue', value)
        },
        buttonClass(active) {
            return [
                'flex-1 px-4 py-1.5 text-sm font-normal leading-5 transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-300 disabled:cursor-not-allowed disabled:opacity-50 sm:flex-none',
                active
                    ? 'bg-blue-600 text-white'
                    : 'bg-white text-blue-600 hover:bg-blue-50',
            ]
        },
    },
}
</script>
